<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-app>
      <div class="row">
        <div class="col-xl-12">
          <CartTable></CartTable>
        </div>
      </div>
    </v-app>

    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import CartTable from "../../../components/cart/CartTable.vue";

/**
 * Product-cart component
 */
export default {
  page: {
    title: "Sepet",
    meta: [{ name: "description", content: "Sepet" }],
  },
  components: { Layout, PageHeader, CartTable },
  computed: {
    
  },
  data() {
    return {
      title: "Sepet",
      items: [
        {
          text: "Sepet",
          active: true,
        },
      ],
    };
  },
  methods: {
    
  },
};
</script>